/* eslint-disable import/prefer-default-export */
export const MODAL_SCREENS = {
  START_UPGRADE: 'start_upgrade',
  UPGRADE_LEVEL: 'upgrade_level',
  INFO_POPUP: 'info_popup',
  INFO_POPUP_DAILY: 'info_popup_daily',
  INFO_POPUP_WEEKLY: 'info_popup_weekly',
};
